// P1-12: Item # is the row's position in the intent list, stored as
// assets.item_number and assigned at import.
//
// Legacy rows have no item_number and are deliberately not backfilled (migration 002
// explains why: they predate any intent list, so there is no row position to recover
// and inventing one would be fiction). The report still has to render for them, so
// they fall back to a stable index assigned after the highest real item_number — which
// can never collide with one, and does not change between two exports of the same
// data.

// Careful with null here: Number(null) is 0, not NaN, so a plain Number.isFinite check
// would read every legacy row as item number zero.
const storedItemNumber = (asset) => {
    if (asset == null || asset.item_number == null) {
        return null;
    }
    const value = Number(asset.item_number);
    return Number.isFinite(value) ? value : null;
};

// Returns a Map of asset id -> the number to display for that asset.
const displayItemNumbers = (assets) => {
    const rows = Array.isArray(assets) ? assets : [];
    const numbered = new Map();

    const realNumbers = rows.map(storedItemNumber).filter(number => number != null);
    let next = realNumbers.length === 0 ? 0 : Math.max(...realNumbers);

    rows.forEach((asset) => {
        const own = storedItemNumber(asset);
        if (own != null) {
            numbered.set(asset.id, own);
        }
    });

    // Ordered by id so the fallback is deterministic across exports.
    rows
        .filter(asset => storedItemNumber(asset) == null)
        .sort((a, b) => Number(a?.id) - Number(b?.id))
        .forEach((asset) => {
            next += 1;
            numbered.set(asset.id, next);
        });

    return numbered;
};

// Sort comparator for report sections, given the map above.
const byItemNumber = (numbers) => (a, b) =>
    (numbers.get(a.id) ?? Number.MAX_SAFE_INTEGER) - (numbers.get(b.id) ?? Number.MAX_SAFE_INTEGER);

const exports = {
    displayItemNumbers,
    byItemNumber,
};

export default exports;
export {
    displayItemNumbers,
    byItemNumber,
};
